(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/components/scratch-animation.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/components/scratch-animation.js');
"use strict";

const typesThatHasCustomScratchAnimation = ['skrapbingo', 'skrapkeno', 'skrapkryss', 'skraplotto', 'trissjubileum', 'triss30'];
const typesThatHasOnlineColor = ['skrapbingo', 'skrapkeno', 'skrapkryss'];
const DEFAULT_SCRATCH_ANIMATION_TYPE = 'triss30';
const ScratchAnimation = _ref => {
  let type = _ref.type,
    _ref$useOnlineColor = _ref.useOnlineColor,
    useOnlineColor = _ref$useOnlineColor === void 0 ? false : _ref$useOnlineColor;
  const onlineColor = useOnlineColor && typesThatHasOnlineColor.includes(type) ? '-online' : '';
  const scratchType = typesThatHasCustomScratchAnimation.includes(type) ? type : DEFAULT_SCRATCH_ANIMATION_TYPE;
  const src = "".concat(svs.core.config.data.svsconfig.cdn, "/images/tickets-validate/scratch-").concat(scratchType).concat(onlineColor, ".gif");
  return React.createElement("img", {
    alt: "Skrapar kontrollruta",
    className: "scratch-gif",
    src: src
  });
};
setGlobal('svs.ticketsValidate.components.ScratchAnimation', ScratchAnimation);

 })(window);